export const NavbarData = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Movies",
    path: "/movies",
  },
  {
    name: "Your List",
    path: "/your-list",
  },
  {
    name: "About",
    path: "/about",
  },
];
